exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/demand/delete-demand/delete-demand.component.css
// module id = ../../../../../src/app/_components/demand/delete-demand/delete-demand.component.css
// module chunks = main